import React from 'react';
import { routes } from '../routes/routes';
import { apiRoutes } from '../api/apiRoutes';
import BadgeIcon from '@mui/icons-material/Badge';
import BusinessIcon from '@mui/icons-material/Business';
import EmailIcon from '@mui/icons-material/Email';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import LuggageIcon from '@mui/icons-material/Luggage';
import Inventory2TwoToneIcon from '@mui/icons-material/Inventory2TwoTone';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import ConnectingAirportsIcon from '@mui/icons-material/ConnectingAirports';
import AirlinesIcon from '@mui/icons-material/Airlines';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import DirectionsSubwayIcon from '@mui/icons-material/DirectionsSubway';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import AssignmentIcon from '@mui/icons-material/Assignment';
import {
  CORE_SIDEBAR_COMPONENT_CONFIG,
  CORE_SIDEBAR_ITEMS,
} from '../../core/config/sidebar/sidebar.config';

export const companySidebarItems = [];

export const sidebarItems = [
  {
    title: 'SIDEBAR.GROUP_GENERAL',
    items: [
      ...(CORE_SIDEBAR_ITEMS.general ?? []),
      {
        title: 'SIDEBAR.PIPELINE',
        icon: <ViewKanbanIcon />,
        url: routes.admin.orders.overview,
      },
      {
        title: 'SIDEBAR.TASKS',
        icon: <AssignmentIcon />,
        url: routes.admin.tasks.list,
      },
      {
        title: 'SIDEBAR.ENQUIRIES',
        icon: <EmailIcon />,
        url: routes.admin.enquiries.list,
      },
      {
        title: 'SIDEBAR.QUOTES',
        icon: <RequestQuoteIcon />,
        url: routes.admin.quotes.list,
      },
      {
        title: 'SIDEBAR.BOOKINGS',
        icon: <BeenhereIcon />,
        url: routes.admin.bookings.list,
      },
      {
        title: 'SIDEBAR.COMPANIES',
        icon: <BusinessIcon />,
        url: routes.admin.companiesV2.list,
        apiUrl: apiRoutes.companiesV2.list,
      },
      {
        title: 'SIDEBAR.TRAVELERS',
        icon: <LuggageIcon />,
        url: routes.admin.travelers.list,
      },
    ],
  },
  {
    title: 'SIDEBAR.GROUP_RESOURCES',
    items: [
      {
        title: 'SIDEBAR.CAR_HIRE_SUPPLIERS',
        icon: <DirectionsCarIcon />,
        url: routes.admin.carHireSuppliers.list,
      },
      {
        title: 'SIDEBAR.CAR_TYPES',
        icon: <AirportShuttleIcon />,
        url: routes.admin.carTypes.list,
      },
      {
        title: 'SIDEBAR.TRANSFER_VENDORS',
        icon: <TransferWithinAStationIcon />,
        url: routes.admin.transferVendors.list,
      },
      {
        title: 'SIDEBAR.RAIL_SUPPLIERS',
        icon: <DirectionsSubwayIcon />,
        url: routes.admin.railSuppliers.list,
      },
      {
        title: 'SIDEBAR.CRUISE_LINES',
        icon: <DirectionsBoatIcon />,
        url: routes.admin.cruiseLines.list,
      },
      {
        title: 'SIDEBAR.SUPPLIERS',
        icon: <Inventory2TwoToneIcon />,
        url: routes.admin.suppliers.list,
      },
      {
        title: 'SIDEBAR.ACCOMMODATIONS',
        icon: <MapsHomeWorkIcon />,
        url: routes.admin.accommodations.list,
      },
      {
        title: 'SIDEBAR.AIRPORTS',
        icon: <ConnectingAirportsIcon />,
        url: routes.admin.airports.list,
        apiUrl: apiRoutes.airports.list,
      },
      {
        title: 'SIDEBAR.AIRLINES',
        icon: <AirlinesIcon />,
        url: routes.admin.airlines.list,
        apiUrl: apiRoutes.airlines.list,
      },
    ],
  },
  {
    title: 'SIDEBAR.GROUP_SETTINGS',
    items: [
      {
        title: 'SIDEBAR.EMPLOYEES',
        icon: <BadgeIcon />,
        url: routes.admin.employees.list,
      },
      ...(CORE_SIDEBAR_ITEMS.settings ?? []),
    ],
  },
];

export const sidebarComponentConfig = {
  component: <>{CORE_SIDEBAR_COMPONENT_CONFIG.component}</>,
};
